import { CommonSuccessResponse } from "constants/types/common";
import { ReceiptResponseType } from "constants/types/receipt";
import useSWR from "swr";

export const useReceiptDetail = (id: string | undefined) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<ReceiptResponseType> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(id ? `/payment-journal/${id}` : null, {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    receipt: data?.data,
    error,
    isLoading,
    mutate,
  };
};
